import React from 'react';
import { LogoFinsightCompact } from '@dealroadshow/uikit-logo/Finsight/Compact';
import { ColorType } from '@creditflowresearch/uilib/Logo/types';
import staticHeaderStyles from './staticHeader.module.scss';

interface IProps {
  title: string,
  tagLine: string,
  children?: React.ReactNode,
  headerBackgroundComponent?: React.FC,
}

const StaticHeader = (props: IProps) => (
  <div className={ staticHeaderStyles.header }>
    <div className={ staticHeaderStyles.content }>
      <div className={ staticHeaderStyles.contentWrapper }>
        <div>
          <h1 className={ staticHeaderStyles.title }>{ props.title }</h1>
          { props.tagLine && (
            <div className={ staticHeaderStyles.tagLine }>{ props.tagLine }</div>
          ) }
        </div>
        { props.children }
      </div>
    </div>
    <div className={ staticHeaderStyles.backgroundWrapper }>
      { props.headerBackgroundComponent
        ? React.createElement(props.headerBackgroundComponent)
        : (
          <LogoFinsightCompact
            colorType={ ColorType.WHITE }
            className={ staticHeaderStyles.backgroundLogo }
          />
        ) }
    </div>
  </div>
);

export default StaticHeader;
